import script from "./TabPane.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabPane.vue?vue&type=script&setup=true&lang=ts"

import "./TabPane.vue?vue&type=style&index=0&id=223dccf3&scoped=true&lang=less"

import exportComponent from "/Users/neal/Desktop/www/qingtv/qingtv-back-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-223dccf3"]])

export default __exports__